module.exports = {
  dashOrValue(displayDash, formattedValue) {
    return displayDash ? '—' : formattedValue;
  }
};
